module.exports = __webpack_public_path__ + "img/1556541907.0d430d6c.jpg";